export default __webpack_public_path__ + "static/media/policy.5cfad2aa.png";